var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto d-flex flex-column box-filter mt-5"})
}
var staticRenderFns = []

export { render, staticRenderFns }